import { canPurchaseStoreDate } from './storeAccess';
import type { HospitalityReservationListItemDTO } from '@/services/hospitality.service';

/**
 * Retorna a primeira reserva cujo período [checkIn, checkOut] cobre TODAS as
 * datas dos produtos do link de pagamento. Reaproveita a regra de janela de
 * compra de `storeAccess.canPurchaseStoreDate`. Retorna null se nenhuma cobrir
 * ou se não houver datas.
 */
export const findReservationForProductDates = (
    productDates: Date[],
    reservations: HospitalityReservationListItemDTO[]
): HospitalityReservationListItemDTO | null => {
    if (productDates.length === 0) return null;

    for (const reservation of reservations) {
        const activeReservation = {
            id: reservation.id,
            checkIn: new Date(reservation.checkIn),
            checkOut: new Date(reservation.checkOut),
        };

        const coversAll = productDates.every(purchaseDate =>
            canPurchaseStoreDate({ purchaseDate, activeReservation })
        );

        if (coversAll) return reservation;
    }

    return null;
};
